import React from "react";

function Footer({ light }) {
  return (
    <footer className={light ? "footer light" : "footer"}>
      <div className="container">
        <span className="copyright">
          ধন্যবাদ | 谢谢 | Thanks | شكرًا | धन्यवाद 
        </span>
      </div>
    </footer>
  );
}

export default Footer;
